'use client';

import { useTranslation } from 'react-i18next';
import { MONTHLY } from '~/constants/dateDurations';
import { PaymentPlanType } from '~/types/listingTypes';
import getRentalLabels from '~/utils/getRentalLabels';

export default function ListingRentalPlan({
  payment_plans,
}: {
  payment_plans?: PaymentPlanType[];
}) {
  const { t } = useTranslation('app');
  const isFirst = (index: number) => index === 0;
  const filteredPlans = payment_plans?.filter((plan) => {
    const duration = plan.duration;
    return duration !== null && duration > 0 && duration !== MONTHLY;
  });
  return (
    <div className="flex flex-wrap gap-x items-center">
      {filteredPlans?.map((plan, index) => {
        const duration = plan.duration;
        return (
          <div className="flex flex-wrap gap-1.5x items-center" key={plan.id}>
            {!isFirst(index) && (
              <div className="flex items-center h-full ">
                <div className="w-[1px] h-[16px]  bg-gray"></div>
              </div>
            )}
            <div className="flex gap-0.5x">
              <span className="text-caption-2 text-gray__dark_1">
                {getRentalLabels(duration, {
                  daily: t('daily'),
                  weekly: t('weekly'),
                  monthly: t('monthly'),
                  yearly: t('yearly'),
                })}
              </span>
              <span className="text-caption-2 text-black">
                {Number(plan.price).toLocaleString()} {t('pound')}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
